export const FETCH_EMPLOYEE_TYPES_REQUEST = 'FETCH_EMPLOYEE_TYPES_REQUEST';
export const FETCH_EMPLOYEE_TYPES_SUCCESS = 'FETCH_EMPLOYEE_TYPES_SUCCESS';
export const FETCH_EMPLOYEE_TYPES_FAILURE = 'FETCH_EMPLOYEE_TYPES_FAILURE';


